import { AxiosCall } from "../models/axios-call.model"
import { AxiosResponse } from "axios"
import { useEffect, useState, useContext } from "react"
import AuthContext from "../context/AuthContext.js"

const useFetchAndLoad = () => {
  const [loading, setLoading] = useState(false)
  const authContext = useContext(AuthContext)
  let controller: AbortController

  const callEndpoint = async (axiosCall: AxiosCall<any>) => {
    if (axiosCall.controller) controller = axiosCall.controller
    setLoading(true)
    let result = {} as AxiosResponse<any>
    try {
      result = await axiosCall.call
    } catch (err) {
      if (err.response.status === 401) {
        authContext.logout()
      }
      setLoading(false)
      throw err
    }
    setLoading(false)
    return result
  }

  const cancelEndpoint = () => {
    setLoading(false)
    controller && controller.abort()
  }

  useEffect(() => {
    return () => {
      cancelEndpoint()
    }
  }, [])

  return { loading, callEndpoint }
}

export default useFetchAndLoad
